import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesginItemChecklist,
  ReportDesignItemChecklistConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-checklist",
  templateUrl: "report-designer-checklist.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerChecklistComponent implements OnInit {
  formData: {
    columns: string;
    rows: string;
    groups: string;
    quickview: boolean;
  } = {
    columns: "",
    rows: "",
    groups: "",
    quickview: false
  };

  @Input()
  item: ReportDesginItemChecklist | undefined;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemChecklistConfig> = new EventEmitter();

  ngOnInit(): void {
    this.formData.columns = this.item?.config.columns || "";
    this.formData.rows = this.item?.config.rows || "";
    this.formData.groups = this.item?.config.groups || "";
    this.formData.quickview = this.item?.config.quickview || false;
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item!.config,
      ...this.formData
    });
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "checklist",
      config: {
        row: this.formData.rows,
        columns: this.formData.columns,
        groups: this.formData.groups
      }
    };
  }
}
